import { createFileRoute } from '@tanstack/react-router';
import EmployeeGroups from 'containers/EmployeeGroups';

export const Route = createFileRoute('/_authenticated/employeeGroups')({
  component: EmployeeGroups,
});
